import { ReportingControllerBaseConfig } from '../../../base';
import { DocumentNewController } from './documentNewInterface';
import { DocumentNewViewProps } from './documentNewProps';
import { BiPlus } from 'react-icons/bi';

export function createDocumentNewController(
    config: ReportingControllerBaseConfig
): DocumentNewController {
    return {
        useProps(context, item, props): DocumentNewViewProps {
            return {
                actions: {
                    create: {
                        label: 'Create new document',
                        Icon: BiPlus,
                        button: {
                            onClick() {
                                if (props.onCreate) {
                                    props.onCreate();
                                }
                            },
                        },
                    },
                },
            };
        },
    };
}
